import {loadingDialog_show} from "../../../../actions";
import {showErrorOnSave} from "../../../FeaturesSetup/featuresAsyncActions";

/**
 * @returns {jobReferrerItemInterface[]}
 * */
export const getReferralPrograms = (fabricatorId) => {
  return getApiConfig('referral/').get(fabricatorId)
};

export const onSaveReferralProgramsClick = (closePopup, popupContext, intl) => {
  return async (dispatch, getState) => {
    console.log("popupContext", popupContext);
    dispatch(loadingDialog_show(true, 'Saving...', "Please wait while the programs are saved"));
    getApiConfig('referral').post(popupContext.referrals)
      .then((response) => {
        console.log('response post referral ->', response);
        dispatch(loadingDialog_show(false));
        if ((!response && !Number.isInteger(response)) || response.error || response.__error__) { // response 0 is ok
          showErrorOnSave(dispatch, response, intl)
          return false
        }
        closePopup();
        return response
      })
      .catch((response) => {
        console.log('error save features ->', response);
        dispatch(loadingDialog_show(false));
        showErrorOnSave(dispatch, response, intl);
        return false
      });
  }
}

export const getDisplayFabricatorName = (fabricator) => {
  return fabricator.companyName
    || (fabricator.fabricatorNames ? fabricator.fabricatorNames.join(', ') : '')
    || fabricator.name
}
